<!--申请退件-->
<template>
<div>
  <el-dialog :title="headMsg" :visible.sync="visible" :fullscreen="isMinScreen" 
        :close-on-click-modal="false" 
        :lose-on-press-escape="false"
        width="400"
    >
    <div v-if="inventory">
        <h3>{{ msg('请录入退件收货信息：') }}</h3>
        <el-form label-width="80px">
            <el-row type="flex" justify="start" style="flex-wrap: wrap;">
                <el-col :xs="24" :sm="16" :md="16" >
                    <el-form-item :label="msg(type==1?'录入取件码':'收货人')" label-width="100px" >
                        <el-input v-model="inventory.receiver" placeholder="必填" size="small"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="type==0" type="flex" justify="start" style="flex-wrap: wrap;">
                <el-col :xs="24" :sm="16" :md="16" >
                    <el-form-item :label="msg('手机号')" label-width="100px" >
                        <el-input v-model="inventory.phone1" placeholder="必填" size="small"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="type==0" type="flex" justify="start" style="flex-wrap: wrap;">
                <el-col :xs="24" :sm="16" :md="16" >
                    <el-form-item :label="msg('详细地址')" label-width="100px" >
                        <el-input v-model="inventory.addr" placeholder="必填" size="small"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex" justify="start" style="flex-wrap: wrap;">
                <el-col :xs="24" :sm="16" :md="16" >
                    <el-form-item :label="msg('留言')" label-width="100px" >
                        <el-input v-model="inventory.note" placeholder="选填" size="small"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex" justify="start" style="flex-wrap: wrap;">
                <el-col :xs="24" :sm="16" :md="16" >
                    <el-form-item :label="msg('紧急联系电话')" label-width="100px" >
                        <el-input v-model="inventory.phone2" placeholder="选填（用于紧急联系）" size="small"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div style="text-align:center; margin-top: 15px;">
            <el-button type="primary" size="mini"  @click="onSubmit()"><i class="el-icon-check"></i><span>{{msg('申请退件')}}</span></el-button>
            <el-button size="mini"  @click="close(false)"><i class="el-icon-close"></i><span>{{msg('取消')}}</span></el-button>
        </div>
    </div>

</el-dialog>
</div>
</template>
<script>

export default {
    name: "InventoryBack",
    components: {
    },
    mounted: function(){

    },
    data() {
        return {
            visible: false,
            inventory: null,
            type:null,
            headMsg:null,
        }
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        },
    },
    methods: {
        showDialog(id,code,type){
            this.inventory = {
                id:id,
                code:code,
                receiver: null,
                phone1: null,
                phone2:null,
                note:null,
                addr: null,
            };
            this.type = type;
            if(type == 1){
                this.headMsg = "平台退件";
            }else{
                this.headMsg = "申请退件";
            }
            this.visible = true;
        }, 
        close(refresh){
            this.visible = false;
            this.$emit("finish", refresh);
        },
        onSubmit(){

            if(!this.inventory.id){
                this.$message(this.msg('请选择需要退件的库存'));
                return;
            }

            if(!this.inventory.receiver || (this.type==0 && !this.inventory.phone1) || (this.type==0 && !this.inventory.addr)){
                this.$message(this.msg('请输入必填项'));
                return;
            }
            
            this.$axios.post(this.$kit.api.inventoryOut.back+"?type="+this.type,this.inventory)
            .then((result) => {
                this.$message(result.msg);
                if(result.status){
                    this.close(true);
                }
            });

        },
    }
}
</script>